import { baseUrlForRTM, baseUrlForTT, getOptions } from "../utilities/heatmapConfig";
import axios from "axios";

class HeatmapService {
  constructor(baseUrlForRTM, baseUrlForTT) {
    this.basePath = "/";
    this.baseUrlTT = `${baseUrlForTT}${this.basePath}`;
    this.baseUrlRTM = `${baseUrlForRTM}${this.basePath}`;
  }

  getHeatmapForTT(token, date, frequency) {
    return axios(
      getOptions(
        this.baseUrlTT,
        `visualization/heatmap?date=${date}&frequency=${frequency}`,
        token
      )
    );
  }

  getHeatmapForRTM(token, date, frequency, line) {
    return axios(
      getOptions(
        this.baseUrlRTM,
        `visualization/heatmap/${line}?date=${date}&frequency=${frequency}`,
        token
      )
    );
  }
}

const heatmapService = new HeatmapService(baseUrlForRTM, baseUrlForTT);

export default heatmapService;
